<template>
  <el-dialog
    v-model="dialogVisible"
    class="memory-status"
    append-to-body
    width="480px">
    <div class="memory-b">
      <template v-if="loading">
        <el-progress type="circle" :percentage="loadingJ"></el-progress>
      </template>
        <template v-else>
          <el-image :src="url" class="memory-b-img"></el-image>
          <div class="memory-b-t">{{ buttonText }}</div>
          <el-button v-if="isButton" size="small"
                      class="memory-b-tt"
                      type="primary"
                      @click="memoryB">{{ status === 'success' ? '查看记录' : '重新计算'  }}</el-button>
        </template>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'memoryStatus',
  data () {
    return {
      dialogVisible: false,
      status: 'success',
      url: 'https://bigdata.topeti.com/wechatRepository/image/memory-success.png',
      buttonText: '',
      config: {},
      loading: false,
      loadingJ: 0,
      isButton: true
    }
  },
  methods: {
    opStatus () {
      this.loading = true
      this.loadingJ = 10
      this.dialogVisible = true
      this.jStim()
    },
    jStim () {
      if (this.loadingJ < 80) {
        setTimeout(() => {
          const i = Math.ceil(Math.random() * 30 + this.loadingJ)
          this.loadingJ = i > 79 ? 80 : i
          if (i < 80) {
            this.jStim()
          }
        }, 500)
      }
    },
    open (res, t, config) {
      console.log('打开', res)
      let str = 'https://bigdata.topeti.com/wechatRepository/image/memory-'
      str += (res.code === 0 ? 'success.png' : 'error.png')
      this.url = str
      this.buttonText = t + (res.code === 0 ? '成功' : '失败')
      this.status = res.code === 0 ? 'success' : 'error'
      this.config = JSON.parse(JSON.stringify(config))
      this.loadingJ = 100
      this.loading = false
      this.dialogVisible = true
      if (!this.isButton) {
        // 没有按钮的情况下直接关闭弹窗
        setTimeout(() => {
          this.dialogVisible = false
          this.$emit('endStatus')
        }, 2000)
      }
    },
    memoryB () {
      this.$emit('memoryGo', {...this.config, status: this.status})
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
  :deep(.memory-status) {
    .el-dialog__header {
      height: 0;
      padding:0;
    }
  }
  .memory-b {
    text-align: center;
    .memory-b-img {
      width: 160px;
      height: 160px;
    }
    .memory-b-t {
      color: #000000;
      font-size: 18px;
      padding-top: 20px;
      padding-bottom: 48px;
    }
  }
</style>
